import React, { useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Modal = ({
  isOpen,
  onClose,
  onConfirm = null, // Only needed for confirmation modals
  title = "Information",
  message = "This is an alert message.",
  confirmText = "OK", // Default for alert modals
  cancelText = null, // Hide cancel button by default
}) => {
  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div
      className="modal show d-block"
      tabIndex="-1"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
      }}
    >
      <div
        className="modal-dialog modal-dialog-centered"
        style={{ maxWidth: "400px" }}
        ref={modalRef}
      >
        <div
          className="modal-content"
          style={{
            borderRadius: "10px",
            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
            border: "none",
          }}
        >
          <div
            className="modal-header"
            style={{ borderBottom: "1px solid #dee2e6" }}
          >
            <div className="modal-title fnt14 fw-600">{title}</div>
            <button
              type="button"
              className="btn-close fnt14"
              onClick={onClose}
              style={{padding: "5px 5px" }}
            ></button>
          </div>
          <div className="modal-body" style={{ padding: "20px" }}>
            <div className="fnt15">{message}</div>
          </div>
          <div
            className="modal-footer"
            style={{
              borderTop: "1px solid #dee2e6",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {cancelText && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
                style={{ borderRadius: "5px", marginRight: "10px" }}
              >
                {cancelText}
              </button>
            )}
            <button
              type="button"
              className="btn btn-primary"
              onClick={onConfirm || onClose} // Closes modal if no confirm function provided
              style={{
                borderRadius: "5px",
                backgroundColor: "#007bff",
                borderColor: "#007bff",
              }}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
